module.exports = __webpack_public_path__ + "static/fieg-dcf8fad95d4c8c5c1a4014f41f50127c.png";